import { createFileRoute } from '@tanstack/react-router';
import { ActivatePage } from '@/features/portal/ActivatePage';

// The invitation link: `/portal/activate#t=<token>`. Public — the token is the
// credential, and it sits after `#` so it never reaches a server log.
export const Route = createFileRoute('/portal/activate')({
  component: ActivatePage,
});
